import {useRouter} from "next/router"
import React, {FC, useContext, useEffect, useState} from "react"
import {CollectionName} from "../../../constants"
import CheckoutContext from "../../../context/CheckoutContext"
import {priceRangeDelimiter} from "../Config"
import PriceFilterSlider from "./PriceFilterSlider"
import {customPlanLengthMap} from "../../bikeDetails/plan/customPlanLengthMap"
import {handleMultiplePriceRanges} from "../../../utility/Helper"

type Props = {
	productsPriceRange: any;
	collectionName: CollectionName;
	customUrlBaseValue?: string;
	getPriceRange?: any;
};

const PriceFilter: FC<Props> = ({collectionName, productsPriceRange, customUrlBaseValue, getPriceRange}): React.ReactElement => {
	const router = useRouter()
	const params = router.query
	const {data} = useContext(CheckoutContext)
	const planLengthMap = customPlanLengthMap[process.env.NEXT_PUBLIC_DISCOUNTS_INSTANCE]
	const planLength = planLengthMap[data?.planLength || 36]

	const urlPriceRange = (params.priceRange as string)?.includes(",") ? handleMultiplePriceRanges((params.priceRange as string))?.split(priceRangeDelimiter) : (params.priceRange as string)?.split(priceRangeDelimiter)

	const selectedPriceRangeInit = () => urlPriceRange?.length > 1 ? urlPriceRange.map(price => Number(price)) : [productsPriceRange?.min, productsPriceRange?.max]
	const [selectedPriceRange, setSelectedPriceRange] = useState<any>(selectedPriceRangeInit())

	useEffect(() => {
		setSelectedPriceRange(selectedPriceRangeInit())
	}, [params.priceRange, params.categories, params?.["accessory-type"]])

	const handleSelectPriceRange = value => {
		setSelectedPriceRange(value)
		getPriceRange(value)
	}

	return (
		<PriceFilterSlider
			customUrlBaseValue={customUrlBaseValue}
			collectionName={collectionName}
			planLength={planLength}
			selectedValues={selectedPriceRange}
			setSelectedPriceRange={handleSelectPriceRange}
			valuesRange={productsPriceRange}
		/>
	)
}

export default PriceFilter
